import mapboxgl from 'mapbox-gl';

// U.S. Bounds
const usBounds = new mapboxgl.LngLatBounds(
  new mapboxgl.LngLat(-127.44954, 21.8288),
  new mapboxgl.LngLat(-62.69594, 49.93376)
);
export const initialBounds = [
  [usBounds._ne.lng, usBounds._ne.lat],
  [usBounds._sw.lng, usBounds._sw.lat]
];

// Max zoom
export const maxZoom = 8;

// Map padding
export const padding = 30;

// Popup offset
export const popupOffset = {
  'bottom-left': [0, -16],
  bottom: [0, -16],
  'bottom-right': [0, -16],
  left: [16, 0],
  right: [-16, 0],
  'top-left': [0, 16],
  top: [0, 16],
  'top-right': [0, 16]
};
